import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { UserProductGroup, UserProductGroupErrorResponse } from '~/Api/User/ProductGroup';
import { handleError } from '~/ErrorHandler';
import { flashErrorMessage, flashSuccessMessage } from '~/FlashMessage';
import { logGoogleTagManagerGroupNotificationSettingsUpdate } from '~/GoogleTagManager';
import { redirectFromDeletedGroup } from '~/ProductGroup';
import { ThunkDispatch } from '~/Store';

import { update } from './actions';
import SettingsModal from './SettingsModal';

function mapDispatchToProps(
	dispatch: ThunkDispatch<AnyAction>,
	props: {
		group: UserProductGroup;
		onChange: (frequency: string) => void;
		onClose: () => void;
	}
): {
	onChange: (frequency: string) => void;
} {
	return {
		onChange: (frequency: string) => {
			props.onChange(frequency);
			logGoogleTagManagerGroupNotificationSettingsUpdate(props.group.id, frequency);

			return dispatch(update(props.group, frequency))
				.then((response) => {
					dispatch(flashSuccessMessage(`Notification settings for "${props.group.name}" successfully saved`));
					return response;
				})
				.catch((response) => {
					if (!(response instanceof UserProductGroupErrorResponse)) {
						dispatch(handleError(response));
						return;
					}
					if (response.handleProductGroupNotFound()) {
						props.onClose();
						dispatch(redirectFromDeletedGroup(props.group));
						dispatch(flashErrorMessage('Cannot change notification settings for removed product list'));
					}
					dispatch(handleError(response));
				});
		},
	};
}

export default connect(null, mapDispatchToProps)(SettingsModal);
